<template>
  <div
    :class="[
      'post',
      { active: isActive },
      { next: isNext },
      { prev: isPrevious }
    ]"
  >
    <div :class="['post-content']">
      <PostUser :username="username" :source="source" />

      <div class="card-body">
        <div
          :class="['image']"
          v-if="image"
          :style="`background-image: url(${image});`"
        >
          <img
            v-if="['instagram', 'twitter'].includes(source)"
            :src="`/static/social-icons/${source}.svg`"
            :class="['social-icon', source]"
          />
        </div>
        <div class="content">
          <PostText
            :post="post"
            :source="source"
            :isActive="isActive"
            @updateHashtags="setHashtags"
          />
        </div>
        <Hashtags :hashtags="hashtags" />
      </div>
    </div>
  </div>
</template>

<script>
import PostText from '@/components/Post/Text';
import PostUser from '@/components/Post/User';
import Hashtags from '@/components/Post/Hashtags';

export default {
  props: ['data', 'isActive', 'isNext', 'isPrevious', 'duration'],

  components: {
    PostText,
    PostUser,
    Hashtags
  },

  data() {
    return {
      hashtags: []
    };
  },

  methods: {
    setHashtags(hashtags) {
      if (!hashtags) {
        return;
      }
      this.hashtags = hashtags;
    }
  },

  computed: {
    post() {
      return JSON.parse(this.data.data);
    },

    source() {
      if (this.post.type === 'wallsio') {
        return 'wallsio';
      }
      return this.post.id_str ? 'twitter' : 'instagram';
    },

    image() {
      switch (this.source) {
        case 'twitter':
          if (this.post.entities.media && this.post.entities.media.length) {
            const {
              id,
              type,
              media_url_https,
              sizes
            } = this.post.entities.media[0];
            return media_url_https;
          }
          return false;
        case 'instagram':
          if (this.post.display_url && !this.post.is_video) {
            return this.post.display_url;
          }
          return this.post.post_image ? this.post.post_image : false;
        case 'wallsio':
          return this.post.post_image;
      }
    },

    username() {
      switch (this.source) {
        case 'twitter':
          return this.post.user.screen_name;
        case 'instagram':
          return this.data.user
            ? JSON.parse(this.data.user).username
            : this.post.external_name;
        case 'wallsio':
          return this.post.external_name;
      }
    },

    hasText() {
      return this.text.length > 0;
    }
  }
};
</script>
